import axios from 'axios';
import BaseUrl from '../util/BaseUrl';

const API_URL = BaseUrl.baseurl+"api/customers";

const getMe = async (token) => {
    try {
        const response = await axios.get(API_URL + '/self', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error', error.response ? error.response.data : error.message);
        throw new Error(error.response ? error.response.data : 'Failed to details');
    }
};

const CustomerService = {
    getMe
};

export default CustomerService;